module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (17).7bb533a9.jpg";